<card name="Чекбоксы">
  <div card content>
    <div class="form-check">
      <check-input type="checkbox">Обычный</check-input>
    </div>

    <div class="form-check">
      <check-input type="checkbox" [value]="true">Выбранный</check-input>
    </div>

    <div class="form-check">
      <check-input type="checkbox" [disabled]="true">Заблокированный</check-input>
    </div>

    <div class="form-check">
      <check-input type="checkbox" [value]="true" [disabled]="true">Выбранный заблок.</check-input>
    </div>
  </div>
</card>

